const RELOAD_KEY = "nema_fe_stale_reload_at";
const STALE_EVENT = "nema:stale-client";

export function isStaleClientError(error) {
  const msg = String(error?.message || error || "").toLowerCase();
  const name = String(error?.name || "").toLowerCase();
  return (
    name === "chunkloaderror" ||
    msg.includes("loading chunk") ||
    msg.includes("chunkloaderror") ||
    msg.includes("failed to fetch dynamically imported module") ||
    msg.includes("importing a module script failed") ||
    msg.includes("error loading dynamically imported module") ||
    msg.includes("dynamically imported module")
  );
}

export function clearStaleReloadMarker() {
  try {
    sessionStorage.removeItem(RELOAD_KEY);
  } catch {
    /* ignore */
  }
}

export function forceRefreshApp() {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.removeItem(RELOAD_KEY);
  } catch {
    /* ignore */
  }
  const url = new URL(window.location.href);
  url.searchParams.set("_nc", String(Date.now()));
  window.location.replace(url.toString());
}

/** One automatic reload per short window — avoids infinite loops. */
export function attemptStaleClientReload() {
  if (typeof window === "undefined") return false;
  const now = Date.now();
  let last = 0;
  try {
    last = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
  } catch {
    return false;
  }
  if (Number.isFinite(last) && now - last < 20000) return false;
  try {
    sessionStorage.setItem(RELOAD_KEY, String(now));
  } catch {
    return false;
  }
  const url = new URL(window.location.href);
  url.searchParams.set("_nc", String(now));
  window.location.replace(url.toString());
  return true;
}

export function notifyStaleClientNeedsRefresh(detail = {}) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(STALE_EVENT, { detail }));
}

/**
 * Handles deploy / cache mismatch (stale index.html pointing at missing JS chunks).
 * Returns true when the error was recognized and handled.
 */
export function handleStaleClientFailure(error) {
  if (!isStaleClientError(error)) return false;
  if (attemptStaleClientReload()) return true;
  notifyStaleClientNeedsRefresh({
    message: error?.message || "Stale application bundle",
  });
  return true;
}

export function registerStaleClientRecoveryListeners() {
  if (typeof window === "undefined") return () => {};

  const onRejection = (event) => {
    if (handleStaleClientFailure(event.reason)) {
      event.preventDefault?.();
    }
  };

  const onError = (event) => {
    const err = event.error || event.message;
    if (handleStaleClientFailure(err)) {
      event.preventDefault?.();
    }
  };

  window.addEventListener("unhandledrejection", onRejection);
  window.addEventListener("error", onError);

  return () => {
    window.removeEventListener("unhandledrejection", onRejection);
    window.removeEventListener("error", onError);
  };
}

export { STALE_EVENT };
